import { postWithoutBody } from "./http";
import { common, pick } from "./i18n";
import type { GenerationOutputStatus, QaVerdict } from "../types";

type QaVerdictMeta = { color: string; label: string };

const qaLabels = {
  pl: { pass: "wierność OK", review: "do weryfikacji", evaluated: "oceniono" },
  en: { pass: "fidelity OK", review: "needs review", evaluated: "evaluated" },
};

export function qaVerdictMeta(verdict: QaVerdict | null | undefined): QaVerdictMeta {
  const labels = pick(qaLabels);
  if (verdict === "pass") return { color: "#15803d", label: labels.pass };
  if (verdict === "review") return { color: "#b45309", label: labels.review };
  return { color: "var(--muted)", label: labels.evaluated };
}

export function generationStatusLabel(status: GenerationOutputStatus) {
  return common().status[status];
}

export async function cancelGenerationJob(productId: number, jobId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/cancel`);
}

export async function retryGenerationOutput(productId: number, jobId: number, outputId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/retry`);
}

export async function regenerateGenerationOutput(productId: number, jobId: number, outputId: number) {
  await postWithoutBody(`/products/${productId}/generation_jobs/${jobId}/outputs/${outputId}/regenerate`);
}
